import {useSelector} from 'react-redux';

import {getHttpMonitorBackgroundKind, HttpMonitorBackgroundKind} from 'features/http/lib/httpMonitorView';
import useBreakpoint from 'shared/lib/hooks/useBreakpoint';
import {userSelector} from 'entities/user';
import {isTranslate} from 'shared/lib/lang';

import {IHttpMonitorItem} from './HttpMonitor/IHttpMonitor';

export interface IUseHttpMonitorDetailsView {
    tzString: string | null | undefined,
    isMobile: boolean,
    backgroundKind: HttpMonitorBackgroundKind,
}

export const useHttpMonitorDetailsView = (item: IHttpMonitorItem): IUseHttpMonitorDetailsView => {
    const user = useSelector(userSelector);
    const breakpoint = useBreakpoint();

    return {
        tzString: user?.timezone,
        isMobile: breakpoint === 'small' || breakpoint === 'mini',
        backgroundKind: getHttpMonitorBackgroundKind(item.status, item.last_code, isTranslate()),
    };
};

export default useHttpMonitorDetailsView;
